module.exports = __webpack_public_path__ + "images/line_lp/section2-left-image_0105e62b24d6eb195724ade4196fc6ea.png";